import MapWrapper from '../../map-wrapper';
import LocationFilters from '../../location-filters';
import './style.scss';
import './style-old.scss';
import StoreList from './store-list';
import OldItkLocationFilters from './location-filters';
import FeatureFilters from './feature-filters';
import { useDebouncedSearch } from '../../../util/misc';
import StoreCards from '../../store-cards';

export default function OldItk() {
    const search = useDebouncedSearch();
    return (
        <div className="map-container old-itk">
            <div className="row">
                <div className="col-9">
                    <div className="marketnavigator-block-filters">
                        <LocationFilters render={OldItkLocationFilters} />
                        <input
                            className="filter-place--select search-filter"
                            type="text"
                            minLength={3}
                            placeholder="Название партнера, город или название улицы"
                            style={{ boxSizing: 'border-box', float: 'right', width: '300px' }}
                            title="Название партнера, город или название улицы"
                            onInput={search}
                        />
                    </div>
                    <MapWrapper style={{ height: '500px', position: 'relative', overflow: 'hidden' }} />
                    <FeatureFilters />
                    <StoreCards render={StoreList} />
                </div>
            </div>
        </div>
    );
}
